import { render, staticRenderFns } from "./ChangeUserGroups.vue?vue&type=template&id=13d90b58"
import script from "./ChangeUserGroups.vue?vue&type=script&lang=js"
export * from "./ChangeUserGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports